export const GIT_COMMIT = "659c7b1", GIT_BRANCH = "main";
